import axios from "axios";
import BaseUrl from "../BaseUrl";
import { getAuthConfig } from "./auth";

const base = BaseUrl();

export const fetchMarkers = async () => {
  const res = await axios.get(`${base}api/user/areas`, getAuthConfig());
  return res.data.success ? res.data.Response : [];
};

export const fetchMarkersLandingPage = async () => {
  const res = await axios.get(`${base}api/user/area_landing_page`);
  return res.data.success ? res.data.Response : [];
};

export const saveArea = async (area) => {
  const res = await axios.post(`${base}api/user/area`, area, getAuthConfig());
  return res.data;
};

export const deleteRating = async (id) => {
  const data = { id: id.id };
  const response = await axios.post(
    `${base}api/user/areas_delete`,
    data,
    getAuthConfig()
  );
  return response.data;
};

export const getCityRedirect = async (city) => {
  try {
    const response = await axios.get(
      `${base}api/user/user_redirect_view/${city}`
    );
    const data = response.data;

    if (data.success && data.Response) {
      return data.Response;
    }
    throw new Error(data.ResponseMessage || 'Unable to load city redirect.');
  } catch (error) {
    console.error('Redirect Fetch Error:', error);
    return null;
  }
};
